import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Img from 'gatsby-image';

const TopImg = styled.div`
    font-size:0px;
    background-size:cover;

    img {
    width:100%;
    max-width:100%;
    height:80%;
    margin-bottom:0;
        }
    @media (min-width:${props => props.theme.breakpoints.md}) {   
        img {
        width:80%;
            }
    }
`;

const Top = ({img,isPc}) => (
    <TopImg>
    {isPc ?
        <Img fluid={img} alt="topkv" style={{width:"80%",left:"10%"}} /> :
        <Img fluid={img} alt="topkv" />
    }
    </TopImg>
);

Top.propTypes = {
    img : PropTypes.object.isRequired,
    isPc : PropTypes.bool.isRequired,
};

export default Top;

